





























































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';
import { Watch } from 'vue-property-decorator';

import Customer from '@/types/customer/Customer';
import UserInterface from '@/types/app/IUser';

import VuetifySelectItems from '@/types/app/vuetifySelectItems';
import Investment from '@/types/app/investment';
import ModalSuccess from '@/components/common/ModalSuccess.vue';
import compareTo from '@/utils/compareTo';
import getCustomers, { CustomerSelectValue } from '@/utils/getCustomers';
import formatMoney from '@/utils/formatMoney';
import formatDate from '@/utils/formatDate';
import Endpoint from '@/utils/endpoint';
import { warn } from 'vue-class-component/lib/util';
import NotificationInterface, {
  notificationInitialValue,
} from '@/types/app/notifications';
import AccountInterface from '@/types/app/accounts';
import ErrorService from '@/services/erroService';

const namespace = 'customer';

interface NotificationType {
  id: string;
  title: string;
}

interface ProductFund {
  fundName: string;
  fundSiteName: string;
  fundId: string;
}

interface ResponseData {
  hasAccount: boolean;
}

interface ProductSelectValue {
  id: string;
  title: string;
  is506c?: boolean;
}

const asyncFilter = async (arr: any[], predicate: any) =>
  Promise.all(arr.map(predicate)).then((results) =>
    arr.filter((_v, index) => results[index])
  );

@Component({
  components: { ModalSuccess },
  data: () => ({
    formType: '',
    notification: notificationInitialValue,
    required: (v: any) => !!v || 'This field is required',
    inputRule: [(v: any) => v.length >= 1 || "Please select a customer"],
    urlRules: [
      (v: any) => !!v || 'URL is required',
      (v: any) =>
        (v && v.length <= 256) ||
        'URL must be less than 256 characters' /* eslint-disable-next-line no-useless-escape*/,
      (v: any) =>/* eslint-disable-next-line no-useless-escape*/
        /https?:[0-9]*\/\/[\w!?/\+\-_~=;\.,*&@#$%\(\)\'\[\]]+/.test(v) ||/* eslint-disable-next-line no-useless-escape*/
        'URL must be valid',
    ],
  })
})
export default class ModalDetail extends Vue {
  @Getter('getModalNewNotificationState', { namespace })
  modalNewNotificationState!: boolean;

  @Action('setModalNewNotificationState', { namespace })
  setModalNewNotificationState!: any;
  @Getter('getCustomersEnabledNotification', { namespace: 'customer' }) customers!: Customer[];
  @Getter('getCustomersAll', { namespace: 'customer' }) customersAll!: Customer[];
  @Action('setModalDeleteState', { namespace }) setModalDeleteState!: any;

  @Getter('getAccountsState', { namespace: 'account' }) accounts!: AccountInterface[];

  @Getter('getLoading', { namespace }) loading!: boolean;
  @Getter('getNotificationSent', { namespace }) notificationSent!: boolean;
  @Getter('getNotificationState', { namespace })
  notificationEdit!: NotificationInterface;

  @Action('setLoading', { namespace }) setLoading!: any;

  @Action('setNotificationSent', { namespace })
  setNotificationSent!: any;

  private endpoint = new Endpoint();

  items: VuetifySelectItems[] = [];

  customersNotification: VuetifySelectItems[] = [];
  filteredCustomers: VuetifySelectItems[] = [];
  selectedCustomers: any[] = [];
  disableCustomers: any[] = [];

  products: VuetifySelectItems[] = [];
  funds: VuetifySelectItems[] = [];
  openSuccessModal = false;
  openSuccessModalMessage = '';
  notification: NotificationInterface = notificationInitialValue;

  notificationData = {
    pageApp: Number(1),
    productId: String(),
    product: { value: String() },
    fund: { value: String() },
    fundId: String(),
  };

  formatDate = formatDate;
  formatMoney = formatMoney;
  formType = 'new';
  required = {};
  urlRules = {};
  inputRule = {};
  notificationLoading = false;

  showConfirmDelete(): void {
    this.setModalNewNotificationState(false);
    this.setModalDeleteState(true);
  }

  @Watch('notificationEdit')
  async loadNotification() {

    //to work with changes in someOtherProp
    if (this.notificationEdit.id) {
      this.formType = 'view';
      this.notification = this.notificationEdit;
      this.$data.filteredCustomers = this.customersNotification.filter(
        (x: VuetifySelectItems) => this.notificationEdit.usersId.some((y) => y == x.value)
      );
      this.selectedCustomers = this.notificationEdit.usersId;
      this.filteredCustomers.forEach(
        (x: VuetifySelectItems) => (x.disabled = true)
      );
    } else {
      this.formType = 'new';
      this.filteredCustomers = [];
      this.filteredCustomers = this.customersNotification;
      this.filteredCustomers.forEach(
        (x: VuetifySelectItems) => (x.disabled = false)
      );
      this.disableCustomers = [];
    }
  }

  @Watch('modalNewNotificationState')
  async loadingInit() {

    this.customersNotification = this.formType == 'view' ? await this.getCustomersAll() : await this.getCustomers();
    this.filteredCustomers = this.formType == 'view' ? this.customersNotification : this.customersNotification;

  }
  async mounted() {
    const [fundResponse, productResponse, notificationTypeResponse] =
      await Promise.all([
        this.getProductFunds(),
        this.getProducts(),
        this.getNotificationTypes(),
      ]);
    this.funds = fundResponse;
    this.products = productResponse;
    this.items = notificationTypeResponse;
  }

  async getNotificationTypes(): Promise<VuetifySelectItems[]> {
    const url = this.endpoint.notificationsTypes;
    const response = await this.$http.get(url);
    const notificationTypes = response.data as NotificationType[];
    const notificationTypesOrdened = notificationTypes.sort((a, b) => {
      if (a.title < b.title) {
        return -1;
      }
      if (b.title < a.title) {
        return 1;
      }
      return 0;
    });

    const itemsForVuetifySelect = notificationTypesOrdened.map(
      (notificationType) => ({
        text: notificationType.title,
        value: notificationType.id,
      })
    );

    return itemsForVuetifySelect;
  }

  get likesAllCustomer() {
    return this.selectedCustomers.length === this.filteredCustomers.length;
  }

  get likesSomeCustomers() {
    return this.selectedCustomers.length > 0 && !this.likesAllCustomer;
  }
  get icon() {
    if (this.likesAllCustomer) return 'mdi-close-box';
    if (this.likesSomeCustomers) return 'mdi-minus-box';
    return 'mdi-checkbox-blank-outline';
  }

  private get form(): HTMLFormElement {
    return this.$refs.form as HTMLFormElement;
  }

  chkClearCustomers() {
    this.selectedCustomers = [];
    this.filteredCustomers = [];
    this.filteredCustomers = this.customersNotification;
    this.notificationData.productId = '';
    this.notificationData.fundId = '';
  }

  toggleSelectAll() {
    this.$nextTick(() => {
      if (this.likesAllCustomer) {
        this.selectedCustomers = [];
      } else {
        this.selectedCustomers = this.filteredCustomers.map(x => x.value);
      }
    });
  }

  async checkCustomerHasAccount(userId: string) {
    return this.accounts.some((x) => x.userId === userId);
  }

  async onChangeFund(fund: VuetifySelectItems) {
    this.notificationData.productId = fund.value;
    this.selectedCustomers = [];
    this.filteredCustomers = this.customersNotification.filter((item) =>
      this.accounts.some((x) => x.userId == item.value && x.fundId == fund.value)
    );
  }

  async onChangeProduct(product: VuetifySelectItems) {
    this.notificationData.productId = product.value;

    if (!product.data.is506c) {
      this.selectedCustomers = [];
      this.filteredCustomers = this.customersNotification.filter(
        (item) =>
          item.data.hasAccount ||
          (item.data.scheduleIndexResponse &&
            item.data.scheduleIndexResponse.status === 'Done')
      );
    }
  }

  async makeANewNotification() {
    if (this.form.validate()) {

      try {
        this.notificationLoading = true;
        if (this.notification.hasAppUrl) {
          //MontarUrl
          if (this.notificationData.pageApp == 2 && this.notificationData.fund)
            this.notification.url = `lesteapp://fundsDetailsScreen/?id=${this.notificationData.fund.value}`;
          else if (
            this.notificationData.pageApp == 3 &&
            this.notificationData.product
          )
            this.notification.url = `lesteapp://opportunitieDetail/?id=${this.notificationData.product.value}`;
          else this.notification.url = 'lesteapp://Home';
        }

        if (this.selectedCustomers.length == 0) {
          this.openSuccessModalMessage =
            'Select at least one customer to send the notification'
          this.openSuccessModal = true;
          this.notificationLoading = false;
        }
        else if (this.selectedCustomers.length > 0) {
          this.notification.usersId = this.selectedCustomers.map((item) => item);
          await this.sendNotification();
          this.notificationLoading = false;
        }
      } catch (error) {
        ErrorService.onError({ status: -1, message: 'Notifications:New:MakeANewNotification', error });
      }

    }
  }

  async sendNotification() {

    this.notificationLoading = true;
    const url = this.endpoint.notifications;
    await this.$http
      .post(url, this.notification)
      .then((res: any) => {
        this.showNotificationSentModal();
        this.clearFields();
        this.closeModal();
      })
      .catch((error) => {
        ErrorService.onError({ status: -1, message: 'Notifications:New:SendNotification', error });
      }).finally(() => {
        this.notificationLoading = false;
      })

  }

  closeModal(): void {
    this.clearFields();
    this.setModalNewNotificationState(false);
  }

  showNotificationSentModal() {
    this.setNotificationSent(true);
  }

  clearFields() {
    this.notification = notificationInitialValue;
    this.notification.title = '';
    this.notification.description = '';
    this.notificationData = {
      pageApp: 1,
      productId: '',
      product: { value: '' },
      fund: { value: '' },
      fundId: '',
    };
    this.chkClearCustomers();
  }

  async getProductFunds(): Promise<VuetifySelectItems[]> {
    const url = this.endpoint.productFund;
    const response = await this.$http.get(`${url}?hasInvestment=true`);
    const productFunds = response.data as ProductFund[];
    const productFundsOrdened = productFunds.sort((a, b) =>
      compareTo(a.fundSiteName, b.fundSiteName)
    );

    const itemsForVuetifySelect = productFundsOrdened.map((productFund) => ({
      text: productFund.fundSiteName,
      value: productFund.fundId,
      data: productFund,
    }));

    return itemsForVuetifySelect;
  }

  async getProducts(): Promise<VuetifySelectItems[]> {
    const url = this.endpoint.productsOnlyPublished;
    const response = await this.$http.get(`${url}&pastOnly=false`);
    const productFunds = response.data as ProductSelectValue[];
    let itemsForVuetifySelect:any[] = [];
    if (productFunds && productFunds.length > 0) {
      const productFundsOrdened = productFunds.sort((a, b) =>
        compareTo(a.title, b.title)
      );

      itemsForVuetifySelect = productFundsOrdened.map((productFund) => ({
        text: productFund.title,
        value: productFund.id,
        data: productFund,
      }));

      
    }
    return itemsForVuetifySelect;
  }

  async getCustomers(): Promise<VuetifySelectItems[]> {
    const customerOrdened = this.customers.sort((a, b) =>
      a.fullName.localeCompare(b.fullName)
    );

    const itemsForVuetifySelect = await Promise.all(
      customerOrdened.map(async (item) => {
        return {
          text: `${item.fullName} - ${item.email}`,
          value: item.id,
          data: {
            ...item,
            hasAccount: await this.checkCustomerHasAccount(item.id),
          },
        };
      })
    );
    return itemsForVuetifySelect;
  }

  async getCustomersAll(): Promise<VuetifySelectItems[]> {
    const customerOrdened = this.customersAll.sort((a, b) =>
      a.fullName.localeCompare(b.fullName)
    );

    const itemsForVuetifySelect = await Promise.all(
      customerOrdened.map(async (item) => {
        return {
          text: `${item.fullName} - ${item.email}`,
          value: item.id,
          data: {
            ...item,
            hasAccount: await this.checkCustomerHasAccount(item.id),
          },
        };
      })
    );
    return itemsForVuetifySelect;
  }
}
